<!-- @format -->

<sis-prior-learning-substitutions
  [courseUnit]="courseUnit"
  [hasValidatablePlan]="!!validatablePlan"
  (openCourseUnitModalEvent)="openCourseUnitModal($event)"></sis-prior-learning-substitutions>
